import                      'babel-polyfill';
import React, {Component}   from 'react';
import PropTypes            from 'prop-types';
import AddApplicantFields   from  '../Fragments/AddApplicantFields';
import Field                from '../Field';
import SubmitInput          from '../Fields/SubmitInput';
import { browserHistory }   from 'react-router';
import FullPageSpinner      from '../Fragments/FullPageSpinner';

let Quote = require('../Managers/Quote');
let HttpService = require('../Managers/HttpService');

class AddTenant extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showManualWarning: false,
            productSelection: null,
            isRentGuaranteeProduct: null,
            showStudentOnlyModal: false,
            minimumIncome: null,
            products: [],
            isFullPageSpinnerActive: false,
            tenantNumber: this.props.params.number ? parseInt(this.props.params.number) : null,
        };
        this.inputComponents = [];

        // Number means we're adding a tenant as part of Case creation
        if (this.props.params.number) {
            // Some quick type checking to ensure we have a valid number to add
            if ((typeof this.state.tenantNumber !== "number") && (Math.floor(this.state.tenantNumber) !== this.state.tenantNumber)) {
                browserHistory.push('/error');
            } else {
                Quote.set('completionMethod', 3, 'BaseIndividualApplication_' + this.state.tenantNumber);
            }
        }
    }

    componentWillMount() {
        // Case ID means we're adding a new tenant to an existing Case
        if (this.props.params.caseId) {
            window.localStorage.clear(); // if we're adding a tenant to a case that alreadt exists, we've landed, so clear cache
            let uuidFormat = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
            if ( ! this.props.params.hash) {
                // No hash = error page
                browserHistory.push('/error/no-auth');
            } else {
                // Set the agent hash
                HttpService.setAgentHash(this.props.params.hash);
            }

            if ( ! this.props.params.caseId || ! uuidFormat.test(this.props.params.caseId)) {
                // No caseId or not a uuid = error page
                browserHistory.push('/error/no-application');
            } else {
                window.localStorage.setItem('caseId', this.props.params.caseId);

                // Wipe any pre-existing data in BaseIndividualApplication
                window.localStorage.removeItem('BaseIndividualApplication');
                Quote.set('completionMethod', 3, 'BaseIndividualApplication');
            }
        }

        let products = JSON.parse(window.localStorage.getItem('AgentProducts'));
        if (window.uorn(products)) {
            // need to give the applicant fields the product array for this agent
            HttpService.getRetrieveProductsForAgent()
            .then(products => {
                this.setState({ products });
                window.localStorage.setItem('AgentProducts', JSON.stringify(products));
            });
        } else {
            this.setState({ products });
        }

        // Set all the legal texts - inject relevant ones to the footer.
        HttpService.getPublicLegalTexts()
        .then(() => {
            document.getElementById('copyright-notice').innerHTML = Quote.getByPath('domainInfo.copyrightNotice');
            document.getElementById('mainPhone').innerHTML = Quote.getByPath('domainInfo.generalTelephone');
        })
        .catch(error => {
            throw error;
        });
    }

    componentDidMount() {
        $('html, body').animate({
            scrollTop: $('body').offset().top - $('header.site-header').height()
        }, 500);
    }

    componentWillUpdate() {
        // get url without trailing slashes
        let url = window.location.href;
        url = url.replace(/\/+$/, "");

        // means were adding a tenant as part of case creation
        if (!window.uorn(this.props.params.number)) {
            let newNumber = url.split('/').pop();
            // if the new number is less than the current and the page ISNT in a loading
            // state, go back via a full refresh
            if (newNumber < this.props.params.number && this.state.isFullPageSpinnerActive === false) {
                window.location.replace('/case/add-another-tenant/' + newNumber);
            }
        }

        this.inputComponents = [];
    }

    componentWillUnmount() {
        this.inputComponents = [];
    }

    completeManually(e) {
        e.preventDefault();
        this.setState({
            showManualWarning: true,
        });
    }

    handleShowManualWarning(v) {
        if (v.toUpperCase() == "NO") {
            this.setState({
                showManualWarning: false,
            });
        } else if (v.toUpperCase() == "YES") {
            let caseId = window.localStorage.getItem('caseId');
            HttpService.validateTenantCreateTenantRedirectToConnect(caseId, this.state.tenantNumber);
        }
    }

    /**
     * Validate form, then post creation of an applicant
     */
    postTenant() {
        this.setState({ isFullPageSpinnerActive: true });
        this.inputComponents.concat(this.addApplicant.getChildInputComponents()).filter(value => {
            return (value !== null) && (value !== undefined) && (value.getChildInstance() !== null) && (value.getChildInstance() !== undefined);
        }).map(v => {
            v.getChildInstance().handleValidation(v.getChildInstance().getCurrentValue());
        });

        setTimeout(() => {
            if (document.querySelectorAll('.has-error').length > 0) {
                $('html, body').animate({
                    scrollTop: $(".has-error").first().offset().top - $('header.site-header').height()
                }, 500);
            } else {
                HttpService.validateNewTenantCreateNewTenant(window.localStorage.getItem('caseId'));
            }
        }, 1000);
    }

    /**
     * Validate form, then redirect to the Case summary
     */
    finishedAddingTenants() {
        this.inputComponents.concat(this.addApplicant.getChildInputComponents()).filter(value => {
            return (value !== null) && (value !== undefined) && (value.getChildInstance() !== null) && (value.getChildInstance() !== undefined);
        }).map(v => {
            v.getChildInstance().handleValidation(v.getChildInstance().getCurrentValue());
        });

        setTimeout(() => {
            if (document.querySelectorAll('.has-error').length > 0) {
                $('html, body').animate({
                    scrollTop: $(".has-error").first().offset().top - $('header.site-header').height()
                }, 500);
            } else {
                this.incrementNumberOfTenants(this.state.tenantNumber);
                browserHistory.push('/case/summary');
            }
        }, 1000);
    }

    /**
     * Increment the total number of tenants, then redirect to add another
     */
    addAnotherTenant() {
        this.inputComponents.concat(this.addApplicant.getChildInputComponents()).filter(value => {
            return (value !== null) && (value !== undefined) && (value.getChildInstance() !== null) && (value.getChildInstance() !== undefined);
        }).map(v => {
            v.getChildInstance().handleValidation(v.getChildInstance().getCurrentValue());
        });

        setTimeout(() => {
            if (document.querySelectorAll('.has-error').length > 0) {
                $('html, body').animate({
                    scrollTop: $(".has-error").first().offset().top - $('header.site-header').height()
                }, 500);
            } else {
                let t = parseInt(this.props.params.number) + 1;
                this.incrementNumberOfTenants(this.state.tenantNumber);

                window.location.assign('/case/add-another-tenant/' + t);
            }
        }, 1000);
    }

    /**
     * Increments the the number of tenants on the case
     */
    incrementNumberOfTenants(v) {
        // Update the number of tenants on the case
        Quote.set('numberOfTenants', v, 'Case');
    }

    render() {
        let numberAsString = ['','one','two','three','four','five','six','seven','eight','nine','ten'];
        // If there is no 'current number', we are coming from Connect, so not
        // needed to create the Application.
        let source;
        if (window.uorn(this.state.tenantNumber)) {
            source = 'BaseIndividualApplication';
        } else {
            source = 'BaseIndividualApplication_' + this.state.tenantNumber;
        }

        return(
            <div>
                <question-row class="header-row">
                    {this.props.currentNumber && this.props.currentNumber === 1?
                        <h2>Details for first tenant</h2>
                    :
                        <h1>Details for tenant {this.state.tenantNumber ? numberAsString[this.state.tenantNumber] : null}</h1>
                    }
                </question-row>

                <FullPageSpinner
                    isActive={this.state.isFullPageSpinnerActive}
                />

                <AddApplicantFields
                    type="tenant"
                    source={source}
                    products={this.state.products}
                    agentStep={true}
                    ref={(instance) => {this.addApplicant = instance;}}
                />

                {/* We handle adding more tenants at the point of application creation differently to when the user has add-tenant as an entry point from an existing application */}
                {this.props.params.number ?
                    <SubmitInput
                        label="Tenant Summary"
                        callbackFunction={this.finishedAddingTenants.bind(this)}
                        backLink={false}
                        saveForLater={false}
                        hasSecondaryButton={true}
                        secondaryButtonText={'Add another tenant'}
                        secondaryButtonAction={this.addAnotherTenant.bind(this)}
                    />
                :
                    <div>
                        <SubmitInput
                            label={'Email to Tenant'}
                            callbackFunction={this.postTenant.bind(this)}
                            backLink={false}
                            saveForLater={false}
                        />

                        <question-row class="no-border">
                            <div className="question-main">
                                <div className="question-top">
                                    <a href="#" onClick={this.completeManually.bind(this)}>Or complete manually</a>
                                </div>
                                {this.state.showManualWarning ?
                                    <div className="supplemental">
                                        <div className="supplemental-bubble">
                                            <div className="arrow" />
                                            <p>Are you sure?</p>
                                            <p>By getting your tenant to complete the form we get the information and the documentation we need much faster. You benefit from the following:</p>
                                            <ul>
                                                <li>Faster turnaround times</li>
                                                <li>Reduced involvement during the process</li>
                                                <li>Reduced contact from us</li>
                                                <li>Enhanced checks on your tenant</li>
                                            </ul>
                                            <p>Do you want to continue to complete the form manually?</p>
                                            <Field
                                                hasBorder={false}
                                                hasPadding={false}
                                                question=""
                                                fieldName="continueToEnterManually"
                                                type="button-choice"
                                                callbackFunction={this.handleShowManualWarning.bind(this)}
                                                options={[
                                                    {
                                                        value: 'yes',
                                                        text: 'Yes'
                                                    },
                                                    {
                                                        value: 'no',
                                                        text: 'No'
                                                    }
                                                ]}
                                            />
                                        </div>
                                    </div>
                                : null}
                            </div>
                        </question-row>
                    </div>
                }
            </div>
        );
    }
}

AddTenant.propTypes = {
    applicationId:  PropTypes.string,
    currentNumber:  PropTypes.number,
    params:         PropTypes.object,
};

export default AddTenant;


// WEBPACK FOOTER //
// ./src/components/Screens/AddTenant.js